import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function LHHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1577">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/6X8oez8pU2MaPWX3uJRPfk/laser-hair-removal.jpg)'
    }} data-id="element-1578" />
      <div className="absolute inset-0 bg-black/60" data-id="element-1579" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-1580">
        <AnimateOnScroll className="w-full lg:w-[60%]" data-id="element-1581">
          <div className="mb-6" data-id="element-1582">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-1583">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1584">
                Treatments
              </a>{' '}
              / Lasers
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1585">
            Be POWERFUL
          </span>

          <h1 className="text-[32px] sm:text-5xl lg:text-[60px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1586">
            LASER HAIR REMOVAL
          </h1>

          <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8" data-id="element-1587">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-1588">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1589">
              Unwanted hair can be an inconvenience for both men and women,
              prompting many to seek solutions that eliminate the need for
              constant shaving, waxing or other temporary methods. Laser hair
              removal is the most effective and long-lasting hair reduction
              method on the market. At Be CLINICAL, our patients love laser hair
              removal because it is precise, fast and predictable.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1590">
              Laser hair reduction targets hair at the follicles, providing a
              more permanent solution to achieve smoother and hair-free skin.
              It's perfect for anyone who wants an easier daily beauty routine.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body italic" data-id="element-1591">
              "Laser hair is one of those things you'll be glad you did! No more
              shaving or plucking! No more nicks or rashes!"
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1592">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}